import { render, staticRenderFns } from "./ManageFavouritesControl.vue?vue&type=template&id=301a0094"
import script from "./ManageFavouritesControl.vue?vue&type=script&lang=js"
export * from "./ManageFavouritesControl.vue?vue&type=script&lang=js"
import style0 from "./ManageFavouritesControl.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports